import LandingPage from "./landing-page.vue";

const promise = new Promise(resolve => {
  vueApp.component('landing-page', LandingPage);
  resolve();
});

window.pendingComponentLoads.push(promise);